import React from 'react';
import { IProps } from './types';

/** 修改會員資料提示頁 */
const memberVerifyComplete:React.FC<IProps> = (props) => {
  return (
    <div className="member-verify-complete auth-block">
      <div className="auth-block__row">
        <p className="auth-block__part">請至會員資料頁修改手機號碼與電子信箱</p>
      </div>
      <div className="auth-block__row">
        <div className="auth-block__complete-icon" />
      </div>
      <div className="auth-block__row">
        <span className="element__button element__button--red" onClick={props.onSubmit}>確認並前往</span>
      </div>
    </div>
  );
};

export default memberVerifyComplete;
